/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps';
import { Link, useNavigate } from 'react-router-dom';
import { DashboardLayoutComponent, PanelDirective, PanelsDirective } from '@syncfusion/ej2-react-layouts';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Toolbar,
  Edit,
  Resize,
  PdfExport,
  ExcelExport,
  Filter,
} from '@syncfusion/ej2-react-grids';

import './analytics.css';
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationLegend, Legend, PieSeries, AccumulationTooltip, AccumulationSelection, SeriesCollectionDirective, AccumulationDataLabel, ChartComponent, ColumnSeries, Category, SeriesDirective, Tooltip, DataLabel, DateTime, SplineAreaSeries, Export, Inject } from '@syncfusion/ej2-react-charts';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import scribeHow from '../data/scribehow.png';
import { Header } from '../components';
import { useStateContext } from '../contexts/ContextProvider';

import { invAnalyticsGrid, notificationGrid, jobsDetailGrid, assetGrid } from '../data/dummy';
import zackatPin from '../data/mappin.png';

const Analytics = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=dashboard');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { isMobile } = useStateContext();

  const { REACT_APP_API_ENDPOINT } = process.env;
  const [invdata, setInventoryData] = useState([]);
  const [jdata, setJobData] = useState([]);
  const [assetdata, setAssetData] = useState([]);
  const [data, setData] = useState([]);
  const [climateMarkers, setClimateMarkers] = useState([]);
  const [cimateCircles, setClimateCircles] = useState([]);
  const [climateBounds, setClimateBounds] = useState([]);
  const [userData, setUser] = useState([]);
  const [jobCount, setJobCount] = useState(0);
  const [invCount, setInvCount] = useState(10);
  const [refresh, setRefresh] = useState(false);
  let dashObj;
  let grid1;
  let grid2;
  let grid3;
  let chart1;
  let pieChart1;
  let pieChart2;
  let assetChart;
  let traffic1;
  const mapRef = useRef(null);
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  const [loading, setLoading] = useState(true);
  let { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env;
  const { REACT_APP_GOOGLE_MAPS_API_KEY_DEV } = process.env;
  const { REACT_APP_ENV } = process.env;
  const { REACT_APP_GOOGLE_MAPS_ID } = process.env;
  if (!REACT_APP_ENV || REACT_APP_ENV === '') {
    REACT_APP_GOOGLE_MAPS_API_KEY = REACT_APP_GOOGLE_MAPS_API_KEY_DEV;
  }

  const [metricmax, setMetricMax] = useState(0);
  const [settingJobs, setSettingJobs] = useState(true);
  const [settingInventory, setSettingInventory] = useState(true);
  const [settingVisits, setSettingVisits] = useState(true);
  const [settingNotification, setSettingNotification] = useState(true);
  const [settingTraffic, setSettingTraffic] = useState(true);
  const [settingActive, setSettingActive] = useState(true);
  const [settingAQI, setSettingAQI] = useState(true);
  const [settingStatistics, setSettingStatisticss] = useState(true);
  const [settingAssets, setSettingAssets] = useState(true);

  const panelData = [
    { text: `${settingJobs ? 'Jobs ✓' : 'Jobs'}`, value: 'jobs' },
    { text: `${settingInventory ? 'Inventory ✓' : 'Inventory'}`, value: 'inventory' },
    { text: `${!settingVisits ? 'Visits ✓' : 'Visits'}`, value: 'visits' },
    { text: `${settingNotification ? 'Notifications ✓' : 'Notifications'}`, value: 'notifications' },
    { text: `${settingTraffic ? 'Traffic ✓' : 'Traffic'}`, value: 'traffic' },
    { text: `${settingActive ? 'Active ✓' : 'Active'}`, value: 'active' },
    { text: `${settingAQI ? 'AQI ✓' : 'AQI'}`, value: 'aqi' },
    { text: `${settingAQI ? 'Statistics ✓' : 'Statistics'}`, value: 'statistics' },
    { text: `${settingAssets ? 'Assets ✓' : 'Assets'}`, value: 'assets' },
  ];
  const [restoreModel, setRestoreModel] = useState([]);
  function chartActions(args) {
    if (args.target.innerText === 'Print') {
      chart1.print();
    } else if (args.target.innerText === 'Export') {
      chart1.exportModule.export('PNG', `Visits by Job_${new Date().getTime()}`);
    }
  }
  function pie1Actions(args) {
    if (args.target.innerText === 'Print') {
      pieChart1.print();
    } else if (args.target.innerText === 'Export') {
      pieChart1.exportModule.export('PNG', `Events this month_${new Date().getTime()}`);
    }
  }
  function assetActions(args) {
    if (args.target.innerText === 'Print') {
      assetChart.print();
    } else if (args.target.innerText === 'Export') {
      assetChart.exportModule.export('PNG', `Asset Location_${new Date().getTime()}`);
    }
  }
  function trafficActions(args) {
    if (args.target.innerText === 'Print') {
      traffic1.print();
    } else if (args.target.innerText === 'Export') {
      traffic1.exportModule.export('PNG', `Job traffic history_${new Date().getTime()}`);
    }
  }
  function pie2Actions(args) {
    if (args.target.innerText === 'Print') {
      pieChart2.print();
    } else if (args.target.innerText === 'Export') {
      pieChart2.exportModule.export('PNG', `Organization Alerts_${new Date().getTime()}`);
    }
  }
  function setUserPreferences(args) {
    if (!dashObj || args.target.textContent !== 'Save') {
      return;
    }
    const model = dashObj.serialize();
    setRestoreModel(model);
    if (!userData.preferences) {
      userData.preferences = {};
    }
    userData.preferences.dashboard = {
      showCharts: {
        settingJobs,
        settingAQI,
        settingAssets,
        settingInventory,
        settingVisits,
        settingNotification,
        settingTraffic,
        settingActive,
        settingStatistics,
      },
      model,
    };
    // Remove the New Password to avoid creating a new password
    userData.newPassword = '';
    // Avoid Password comparison
    userData.password = '';
    if (userData.lastLogin && userData.lastLogin === '') {
      userData.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(userData),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          alert(responseJson.response);
        }
        setRefresh(!refresh);
      })
      .catch((error) => {
        navigate('/login');
      });
  }
  function setSettings(e) {
    if (e.value.includes('Visits')) {
      setSettingVisits(!settingVisits);
    } else if (e.value.includes('Jobs')) {
      setSettingJobs(!settingJobs);
    } else if (e.value.includes('Traffic')) {
      setSettingTraffic(!settingTraffic);
    } else if (e.value.includes('Active')) {
      setSettingActive(!settingActive);
    } else if (e.value.includes('Notifications')) {
      setSettingNotification(!settingNotification);
    } else if (e.value.includes('Inventory')) {
      setSettingInventory(!settingInventory);
    } else if (e.value.includes('AQI')) {
      setSettingAQI(!settingAQI);
    } else if (e.value.includes('Statistics')) {
      setSettingStatisticss(!settingStatistics);
    } else if (e.value.includes('Assets')) {
      setSettingAssets(!settingAssets);
    }
  }
  const actionComponent = () => (
    <div>
      <DropDownListComponent id="ddlelement" dataSource={panelData} placeholder="Chart Selection" onChange={setSettings} />
    </div>
  );
  let total = 0;

  const datajobs = [];
  const notjobs = [];
  const [activeassociates, setActiveAssociates] = useState([]);
  const [notmax, setNotMax] = useState(0);
  const resize = ['e-south-east', 'e-east', 'e-west', 'e-north', 'e-south'];

  const sortingOptions = {
    columns: [{ field: 'status', direction: 'Ascending' }],
  };
  const invSortingOptions = {
    columns: [{ field: '_id.status', direction: 'Ascending' }],
  };
  const notSortingOptions = {
    columns: [{ field: 'org', direction: 'Ascending' }],
  };

  async function renderMarkers(map, point, pointname, icon) {
    const newCenter = { lng: point.lng, lat: point.lat };
    // const mypin = 'http://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png';
    const infowindow = new window.google.maps.InfoWindow({
      content: `<div style='float:left'><img src='${icon}'></div><div style='float:right; padding: 10px;'><b>Title</b><br/>${pointname}</div>`,
    });
    //    const marker = new maps.Marker({
    // const { AdvancedMarkerElement, PinElement } = await window.google.maps.importLibrary('marker');
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');

    const customIcon = document.createElement('img');
    customIcon.src = `${zackatPin}`;
    customIcon.style.width = '50px';
    customIcon.style.height = '50px';
    const marker = new AdvancedMarkerElement({
      position: newCenter,
      map,
      content: customIcon,
      title: pointname,
    });

    marker.addListener('gmp-click', () => {
      infowindow.open({
        anchor: marker,
      });
    });
    // mapRef.current.setCenter(newCenter);
    return marker;
  }
  async function renderCircle(map, point, pointname, color) {
    const newCenter = { lng: point.lng, lat: point.lat };
    const circle = new window.google.maps.Circle({
      key: pointname,
      strokeColor: '#FF0000',
      strokeOpacity: '0.8',
      strokeWeight: '2',
      fillColor: color,
      fillOpacity: '0.35',
      center: newCenter,
      map,
      radius: 32186,
    });
    return circle;
  }
  const componentToHex = (c) => {
    const hex = c.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  };
  const rgbToHex = (r, g, b) => `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
  const headerNotifications = () => (
    <div className="card">
      <span className="e-icons notifications" />
      <div className="card-content textaqi">Notification Statistics</div>
    </div>
  );

  const renderMap = () => {
    const map = mapRef.current;
    if (data && data[4] && data[4].length > 0) {
      const polygons = [];
      const bounds = new window.google.maps.LatLngBounds();

      data[4].forEach((element) => {
        let color = 'yellow';
        let category = '';
        let icon = zackatPin;
        if (element.aqi && element.aqi.hourlyforecasts && element.aqi.hourlyforecasts.length > 0 && element.aqi.hourlyforecasts[0].indexes.length > 0 && element.aqi.hourlyforecasts[0].indexes[0].color) {
          const red = element.aqi.hourlyforecasts[0].indexes[0].color.red * 255;
          const green = element.aqi.hourlyforecasts[0].indexes[0].color.green * 255;
          const blue = element.aqi.hourlyforecasts[0].indexes[0].color.blue * 255;
          category = `AQI: ${element.aqi.hourlyforecasts[0].indexes[0].category} ${element.aqi.hourlyforecasts[0].indexes[0].aqi}`;
          color = rgbToHex(Number(red.toFixed(0)), Number(green.toFixed(0)), Number(blue.toFixed(0)));
        }
        if (element.forecast && element.forecast.forecastdays && element.forecast.forecastdays.length > 0) {
          icon = `${element.forecast.forecastdays[0].daytimeforecast.weathercondition.iconbaseuri}.svg`;
          category += `<br />Forecast: ${element.forecast.forecastdays[0].daytimeforecast.weathercondition.description.text} ${element.forecast.forecastdays[0].daytimeforecast.weathercondition.type}`;
        }
        const coords = [];
        if (element.document) {
          if (element.document.placemark && element.document.placemark.length > 0) {
            element.document.placemark.forEach((place) => {
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.poly) {
                place.polygon.outerBoundaryIs.linearRing.poly.forEach((coord) => {
                  const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                  coords.push(c);
                });
                if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.path) {
                  place.polygon.outerBoundaryIs.linearRing.path.forEach((coord) => {
                    const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                    coords.push(c);
                  });
                }
              }
            });
            if (coords.length > 0) {
              renderMarkers(map, coords[0], `${element.document.name}<br />${category}`, icon);
              const poly = new window.google.maps.Polygon({
                paths: coords,
                strokeColor: '#383838',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: 'orange',
                fillOpacity: 0.85,
                map,
              });
              polygons.push(poly);
              renderCircle(map, coords[0], element.document.name, color);
            } else if (element.document.placemark && element.document.placemark.length > 0 && element.document.placemark[0].coordinates && element.document.placemark[0].coordinates.point) {
              const pt = element.document.placemark[0].coordinates.point.split(',');
              if (pt.length >= 2) {
                coords.push({ lat: pt[0], lng: pt[1] });
                const poly = new window.google.maps.Polygon({
                  paths: coords,
                  strokeColor: '#383838',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: 'orange',
                  fillOpacity: 0.85,
                  map,
                });
                polygons.push(poly);
              }
              renderCircle(map, coords[0], element.document.name, color);
            }
          }
          // Try Folder
          if (element.document && element.document.folder && element.document.folder.placemark && element.document.folder.placemark.length > 0) {
            element.document.folder.placemark.forEach((place) => {
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.poly) {
                place.polygon.outerBoundaryIs.linearRing.poly.forEach((coord) => {
                  const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                  coords.push(c);
                });
              }
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.path) {
                place.polygon.outerBoundaryIs.linearRing.path.forEach((coord) => {
                  const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                  coords.push(c);
                });
              }
            });
            if (coords.length > 0) {
              renderMarkers(map, coords[0], `${element.document.folder.name}<br />${category}`, icon);
              const poly = new window.google.maps.Polygon({
                paths: coords,
                strokeColor: '#383838',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: 'red',
                fillOpacity: 0.85,
                map,
              });
              polygons.push(poly);
              renderCircle(map, coords[0], element.document.folder.name, color);
            } else if (element.document.folder.placemark && element.document.folder.placemark.length > 0 && element.document.folder.placemark[0].coordinates && element.document.folder.placemark[0].coordinates.point) {
              const pt = element.document.folder.placemark[0].coordinates.point.split(',');
              if (pt.length >= 2) {
                coords.push({ lat: pt[0], lng: pt[1] });
                const poly = new window.google.maps.Polygon({
                  paths: coords,
                  strokeColor: '#383838',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: 'red',
                  fillOpacity: 0.85,
                  map,
                });
                polygons.push(poly);
              }
              renderCircle(map, coords[0], element.document.folder.name, color);
            }
          }
        }
        // Construct the polygon.
      });
      for (let j = 0; j < polygons.length; j += 1) {
        for (let i = 0; i < polygons[j].getPath().getLength(); i += 1) {
          bounds.extend(polygons[j].getPath().getAt(i));
        }
      }
      mapRef.current.fitBounds(bounds);
    }
  };
  const setMarkers = (mydata) => {
    if (mydata && mydata[4] && mydata[4].length > 0) {
      const polygons = [];
      const bounds = [];
      const coords = [];

      mydata[4].forEach((element) => {
        let color = 'yellow';
        let category = '';
        let icon = zackatPin;
        if (element.aqi && element.aqi.hourlyforecasts && element.aqi.hourlyforecasts.length > 0 && element.aqi.hourlyforecasts[0].indexes.length > 0 && element.aqi.hourlyforecasts[0].indexes[0].color) {
          const red = element.aqi.hourlyforecasts[0].indexes[0].color.red * 255;
          const green = element.aqi.hourlyforecasts[0].indexes[0].color.green * 255;
          const blue = element.aqi.hourlyforecasts[0].indexes[0].color.blue * 255;
          category = `AQI: ${element.aqi.hourlyforecasts[0].indexes[0].category} ${element.aqi.hourlyforecasts[0].indexes[0].aqi}`;
          color = rgbToHex(Number(red.toFixed(0)), Number(green.toFixed(0)), Number(blue.toFixed(0)));
        }
        if (element.forecast && element.forecast.forecastdays && element.forecast.forecastdays.length > 0) {
          icon = `${element.forecast.forecastdays[0].daytimeforecast.weathercondition.iconbaseuri}.svg`;
          category += `<br />Forecast: ${element.forecast.forecastdays[0].daytimeforecast.weathercondition.description.text} ${element.forecast.forecastdays[0].daytimeforecast.weathercondition.type}`;
        }
        if (element.document) {
          if (element.document.placemark && element.document.placemark.length > 0) {
            element.document.placemark.forEach((place) => {
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.poly) {
                place.polygon.outerBoundaryIs.linearRing.poly.forEach((coord) => {
                  const c = { _id: element._id, lat: Number(coord.lat), lng: Number(coord.lng) };
                  coords.push(c);
                });
                if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.path) {
                  place.polygon.outerBoundaryIs.linearRing.path.forEach((coord) => {
                    const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                    coords.push(c);
                  });
                }
              }
            });
            if (coords.length > 0) {
              const poly = new window.google.Polygon({
                paths: coords,
                strokeColor: '#383838',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: 'orange',
                fillOpacity: 0.85,
              });
              polygons.push(poly);
            } else if (element.document.placemark && element.document.placemark.length > 0 && element.document.placemark[0].coordinates && element.document.placemark[0].coordinates.point) {
              const pt = element.document.placemark[0].coordinates.point.split(',');
              if (pt.length >= 2) {
                coords.push({ _id: element._id, lat: pt[0], lng: pt[1] });
                const poly = new window.google.Polygon({
                  paths: coords,
                  strokeColor: '#383838',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: 'orange',
                  fillOpacity: 0.85,
                });
                polygons.push(poly);
              }
            }
          }
          // Try Folder
          if (element.document && element.document.folder && element.document.folder.placemark && element.document.folder.placemark.length > 0) {
            element.document.folder.placemark.forEach((place) => {
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.poly) {
                place.polygon.outerBoundaryIs.linearRing.poly.forEach((coord) => {
                  const c = { _id: element._id, lat: Number(coord.lat), lng: Number(coord.lng) };
                  coords.push(c);
                });
              }
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.path) {
                place.polygon.outerBoundaryIs.linearRing.path.forEach((coord) => {
                  const c = { _id: element._id, lat: Number(coord.lat), lng: Number(coord.lng) };
                  coords.push(c);
                });
              }
            });
            if (coords.length > 0) {
              const poly = new window.google.Polygon({
                paths: coords,
                strokeColor: '#383838',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: 'red',
                fillOpacity: 0.85,
              });
              polygons.push(poly);
            } else if (element.document.folder.placemark && element.document.folder.placemark.length > 0 && element.document.folder.placemark[0].coordinates && element.document.folder.placemark[0].coordinates.point) {
              const pt = element.document.folder.placemark[0].coordinates.point.split(',');
              if (pt.length >= 2) {
                coords.push({ _id: element._id, lat: pt[0], lng: pt[1] });
                const poly = new window.google.Polygon({
                  paths: coords,
                  strokeColor: '#383838',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: 'red',
                  fillOpacity: 0.85,
                });
                polygons.push(poly);
              }
            }
          }
        }
        // Construct the polygon.
      });
      /*
      for (let j = 0; j < polygons.length; j += 1) {
        for (let i = 0; i < polygons[j].getPath().getLength(); i += 1) {
          bounds.extend(polygons[j].getPath().getAt(i));
        }
      }
        */
      setClimateMarkers(coords);
      setClimateCircles(polygons);
      setClimateBounds(bounds);
    }
  };

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/dashboard?${query}`;
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          if (mydata && mydata.user) {
            setUser(mydata.user);
            if (mydata.user && mydata.user.preferences && mydata.user.preferences.dashboard) {
              if (mydata.user.preferences.dashboard.showCharts) {
                setSettingAQI(mydata.user.preferences.dashboard.showCharts.settingAQI);
              }
              if (mydata.user && mydata.user.preferences.dashboard && mydata.user.preferences.dashboard.showCharts) {
                setSettingActive(mydata.user.preferences.dashboard.showCharts.settingActive);
                setSettingTraffic(mydata.user.preferences.dashboard.showCharts.settingTraffic);
                setSettingJobs(mydata.user.preferences.dashboard.showCharts.settingJobs);
                setSettingNotification(mydata.user.preferences.dashboard.showCharts.settingNotification);
                setSettingStatisticss(mydata.user.preferences.dashboard.showCharts.settingStatistics);
                setSettingVisits(mydata.user.preferences.dashboard.showCharts.settingVisits);
                setSettingInventory(mydata.user.preferences.dashboard.showCharts.settingInventory);
                setSettingAssets(mydata.user.preferences.dashboard.showCharts.settingAssets);
              }

              if (mydata.user.preferences.dashboard.model && mydata.user.preferences.dashboard.model.length > 0) {
                setRestoreModel(mydata.user.preferences.dashboard.model);
              }
            }
          }
          if (mydata && mydata.charts && mydata.charts.length >= 1) {
            setData(mydata.charts);
            setInventoryData(mydata.charts[0]);
            setInvCount(mydata.charts[0].length);
            if (mydata.charts && mydata.charts.length >= 4) {
              setJobCount(mydata.charts[3].length);
              setJobData(mydata.charts[3]);
              if (mydata.charts && mydata.charts.length >= 7) {
                setActiveAssociates(mydata.charts[6]);
              }
              if (mydata.charts && mydata.charts.length >= 9) {
                setAssetData(mydata.charts[8]);
              }
            }
          }
          // setMarkers(mydata.charts);
          setLoading(false);
        })
        .catch(() => {
        });
    };
    dataFetch();
  }, [refresh]);
  useEffect(() => {
    if (dashObj) {
      restoreModel.forEach((panel) => {
        dashObj.movePanel(panel.id, panel.row, panel.col);
        dashObj.resizePanel(panel.id, panel.sizeX, panel.sizeY);
      });
    }
  }, [restoreModel]);

  const load = (args) => {
    let selectedTheme = window.location.hash.split('/')[1];
    selectedTheme = selectedTheme || 'Material';
    args.accumulation.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast').replace(/-dark/i, 'Dark');
  };
  const Chartload = (args) => {
    let selectedTheme = window.location.hash.split('/')[1];
    selectedTheme = selectedTheme || 'Material';
    args.chart.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast').replace(/-dark/i, 'Dark');
    if (selectedTheme === 'highcontrast') {
      args.chart.series[0].marker.dataLabel.fill = '#000000';
      args.chart.series[1].marker.dataLabel.fill = '#000000';
    }
  };
  const toolbarOptions = ['Search', 'PdfExport', 'ExcelExport'];
  const onToolbarChange = (args) => {
    let grid = grid1;
    const g = args.item.properties.id.split('_')[0];
    switch (g) {
      case 'invGrid':
        grid = grid3;
        break;
      case 'jobsGrid':
        grid = grid2;
        break;
      case 'assetCard':
        grid = assetChart;
        break;
      default:
        break;
    }

    if (grid && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Dashboard_${g}_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.pdfExport(properties);
    } else if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_Dashboard_${g}_${new Date().toISOString()}.xlsx`,
      };
      grid.excelExport(properties);
    }
  };

  const cellSpacing = [5, 5];
  const card1 = () => (
    <div style={{ height: '90%', width: '100%' }}>
      <div className="card">
        <span className="e-icons session" />
        <div className="card-content text">Notifications</div>
        <div className="card-content number">{total}</div>
      </div>
      <GridComponent
        id="noGrid"
        ref={(scope) => { grid1 = scope; }}
        dataSource={notjobs[0]}
        toolbar={toolbarOptions}
        allowPaging
        allowSorting
        allowResizing
        sortSettings={notSortingOptions}
        allowPdfExport
        allowExcelExport
        pageSettings={{ pageSize: 5, pageCount: 5 }}
      >
        <ColumnsDirective>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          {notificationGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
        </ColumnsDirective>
        <Inject services={[Page, Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport]} />
      </GridComponent>
    </div>
  );
  const card2 = () => (
    <div>
      <div className="card">
        <span className="e-icons profile" />
        <div className="card-content text">Jobs</div>
        <div className="card-content number">{jobCount}</div>
      </div>
      <GridComponent
        ref={(scope) => { grid2 = scope; }}
        id="jobsGrid"
        dataSource={jdata}
        toolbar={toolbarOptions}
        toolbarClick={onToolbarChange}
        allowPaging
        allowSorting
        allowResizing
        sortSettings={sortingOptions}
        allowPdfExport
        allowExcelExport
        pageSettings={{ pageSize: 5, pageCount: 5 }}
      >
        <ColumnsDirective>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          {jobsDetailGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
        </ColumnsDirective>
        <Inject services={[Page, Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport]} />
      </GridComponent>
    </div>
  );
  const card3 = () => (
    <div style={{ height: '90%', width: '100%' }}>
      <div className="card">
        <span className="e-icons views" />
        <div className="card-content text">Inventory</div>
        <div className="card-content number">{invCount}</div>
      </div>
      <GridComponent
        id="invGrid"
        ref={(scope) => { grid3 = scope; }}
        dataSource={invdata}
        toolbar={toolbarOptions}
        toolbarClick={onToolbarChange}
        allowPaging
        allowSorting
        allowResizing
        sortSettings={invSortingOptions}
        allowPdfExport
        allowExcelExport
        pageSettings={{ pageSize: 5, pageCount: 5 }}
      >
        <ColumnsDirective>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          {invAnalyticsGrid.map((item, index) => <ColumnDirective key={index} {...item} allowSorting />)}
        </ColumnsDirective>
        <Inject services={[Page, Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport]} />
      </GridComponent>
    </div>
  );
  const pie = () => (
    <div style={{ height: '100%', width: '100%' }}>
      <ToolbarComponent
        id="toolbar"
        orientation="Horizontal"
        onClick={pie1Actions}
      >
        <ItemsDirective>
          <ItemDirective text="Print" prefixIcon="e-print" />
          <ItemDirective text="Export" prefixIcon="e-export-excel" />
        </ItemsDirective>
      </ToolbarComponent>
      <AccumulationChartComponent
        ref={(pieChart) => { pieChart1 = pieChart; }}
        id="pie"
        title="Events this month"
        legendSettings={{ visible: true }}
        enableSmartLabels
        height="100%"
        width="100%"
        enableAnimation={false}
        selectionMode="Point"
        center={{ x: '50%', y: '50%' }}
        tooltip={{ enable: false, header: '<b>${point.x}</b>', format: 'Composition : <b>${point.y}%</b>' }}
        load={load}
      >
        <Inject services={[AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel, AccumulationSelection, Export]} />
        <AccumulationSeriesCollectionDirective>
          <AccumulationSeriesDirective dataSource={activeassociates} name="_id.name[0]" xName="_id.name[0]" yName="count" explode={false} dataLabel={{ visible: true, position: 'Inside', name: 'text', font: { fontWeight: '600' } }} radius="100%" innerRadius="35%" palettes={['#357cd2', '#00bdae', '#e36593']} />
        </AccumulationSeriesCollectionDirective>
      </AccumulationChartComponent>
    </div>
  );
  const assetPie = () => (
    <div style={{ height: '90%', width: '100%' }}>
      <div className="card">
        <span className="e-icons views" />
      </div>
      <GridComponent
        id="assetCard"
        ref={(scope) => { assetChart = scope; }}
        dataSource={assetdata}
        toolbar={toolbarOptions}
        toolbarClick={onToolbarChange}
        allowPaging
        allowSorting
        allowResizing
        allowPdfExport
        allowExcelExport
        pageSettings={{ pageSize: 5, pageCount: 5 }}
      >
        <ColumnsDirective>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          {assetGrid.map((item, index) => <ColumnDirective key={index} {...item} allowSorting />)}
        </ColumnsDirective>
        <Inject services={[Page, Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport]} />
      </GridComponent>
    </div>
  );
  const assetPieK = () => (
    <div style={{ height: '100%', width: '100%' }}>
      <ToolbarComponent
        id="toolbar"
        orientation="Horizontal"
        onClick={assetActions}
      >
        <ItemsDirective>
          <ItemDirective text="Print" prefixIcon="e-print" />
          <ItemDirective text="Export" prefixIcon="e-export-excel" />
        </ItemsDirective>
      </ToolbarComponent>
      <AccumulationChartComponent
        ref={(p) => { assetChart = p; }}
        id="assets"
        title="Asset Location"
        legendSettings={{ visible: true }}
        enableSmartLabels
        height="100%"
        width="100%"
        enableAnimation={false}
        selectionMode="Point"
        center={{ x: '50%', y: '50%' }}
        tooltip={{ enable: false, header: '<b>${point.x}</b>', format: 'Composition : <b>${point.y}%</b>' }}
        load={load}
      >
        <Inject services={[AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel, AccumulationSelection, Export]} />
        <AccumulationSeriesCollectionDirective>
          {assetdata.map((item, index) => <AccumulationSeriesDirective xName="_id.location[0]" dataSource={item} yName="count" explode explodeIndex={1} explodeOffset="10%" dataLabel={{ visible: true, position: 'Inside', name: 'text', font: { fontWeight: '600' } }} radius="100%" key={index} />)}
        </AccumulationSeriesCollectionDirective>
      </AccumulationChartComponent>
    </div>
  );
  const visitorsChart = () => (
    <div style={{ height: '100%', width: '100%' }}>
      <ToolbarComponent
        id="toolbar"
        orientation="Horizontal"
        onClick={trafficActions}
      >
        <ItemsDirective>
          <ItemDirective text="Print" prefixIcon="e-print" />
          <ItemDirective text="Export" prefixIcon="e-export-excel" />
        </ItemsDirective>
      </ToolbarComponent>

      <ChartComponent
        id="visitorsChart"
        ref={(trafficChart) => { traffic1 = trafficChart; }}
        style={{ textAlign: 'center' }}
        load={Chartload}
        legendSettings={{ visible: true }}
        primaryXAxis={{ valueType: 'DateTime', labelFormat: 'M/y', labelRotation: -45, majorGridLines: { width: 0 }, intervalType: 'Months', edgeLabelPlacement: 'Shift' }}
        primaryYAxis={{ labelFormat: '{value}', lineStyle: { width: 0 }, maximum: metricmax, interval: 10, majorTickLines: { width: 0 }, minorTickLines: { width: 0 } }}
        chartArea={{ border: { width: 0 } }}
      >
        <Inject services={[SplineAreaSeries, DateTime, Legend, Export]} />
        <SeriesCollectionDirective>
          {datajobs.map((item, index) => <SeriesDirective xName="x" dataSource={item} yName="y" name={item[0].title} type="SplineArea" width={2} key={index} />)}
          {/*
          {dataj1.length > 0 ? <SeriesDirective dataSource={dataj1} xName="x" yName="y" name="Time" opacity={0.5} type="SplineArea" width={2} /> : ''}
        */}
        </SeriesCollectionDirective>
      </ChartComponent>
    </div>
  );
  const defaultMapOptions = {
    fullscreenControl: true,
    zoomControl: true,
    mapTypeControl: true,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: true,
    mapId: REACT_APP_GOOGLE_MAPS_ID,
  };

  const headerActive = () => (
    <div className="card">
      <span className="e-icons active" />
      <div className="card-content textaqi">Active Associates</div>
    </div>
  );
  const headerTraffic = () => (
    <div className="card">
      <span className="e-icons traffic" />
      <div className="card-content textaqi">Job Traffic History</div>
    </div>
  );
  const headerAssets = () => (
    <div className="card">
      <span className="e-icons assets" />
      <div className="card-content textaqi">Asset Tracking</div>
    </div>
  );
  const headerAQI = () => (
    <div className="card">
      <span className="e-icons aqi" />
      <div className="card-content textaqi">Job AQI/Temperature</div>
    </div>
  );
  const climateChartNew = () => (
    <APIProvider
      apiKey={`${REACT_APP_GOOGLE_MAPS_API_KEY}`}
      onLoad={onMapLoad}
    >
      <Map
        style={{ width: '100%', height: '100vh' }}
        defaultCenter={{
          lng: -96.8172843880738, lat: 33.09087757313318,
        }}
        mapId={`${REACT_APP_GOOGLE_MAPS_ID}`}
        defaultZoom={10}
      >
        {climateMarkers.map((marker, index) => (
          <AdvancedMarker
            className="bounce"
            key={`${marker._id}_${index}`}
            draggable
            position={marker}
          >
            <img src={zackatPin} width="60px" height="60px" />
          </AdvancedMarker>
        ))}
      </Map>
    </APIProvider>
  );

  const climateChart = () => (
    <div style={{ height: '100%', width: '100%' }} ref={mapRef}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: REACT_APP_GOOGLE_MAPS_API_KEY,
          mapTypeId: 'terrain',
        }}
        defaultCenter={{
          lng: -96.8172843880738, lat: 33.09087757313318,
        }}
        defaultZoom={10}
        yesIWantToUseGoogleMapApiInternals
        options={defaultMapOptions}
        allowResizing
        onGoogleApiLoaded={({ map, maps }) => {
          mapRef.current = map;
          renderMap(map);
        }}
      />
    </div>
  );

  const pieChart = () => (
    <div style={{ height: '100%', width: '100%' }}>
      <ToolbarComponent
        id="toolbar"
        orientation="Horizontal"
        onClick={pie2Actions}
      >
        <ItemsDirective>
          <ItemDirective text="Print" prefixIcon="e-print" />
          <ItemDirective text="Export" prefixIcon="e-export-excel" />
        </ItemsDirective>
      </ToolbarComponent>

      <AccumulationChartComponent
        id="pieChart"
        ref={(pie2) => { pieChart2 = pie2; }}
        title="Alerts Organizations/month"
        legendSettings={{ visible: true }}
        enableSmartLabels
        height="90%"
        width="90%"
        enableAnimation={false}
        selectionMode="Point"
        center={{ x: '50%', y: '50%' }}
        tooltip={{ enable: false, header: '<b>${point.x}</b>', format: 'Composition : <b>${point.y}%</b>' }}
        load={load}
      >
        <Inject services={[AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel, AccumulationSelection, Export]} />
        <AccumulationSeriesCollectionDirective>
          {/* <AccumulationSeriesDirective dataSource={pieChartData} xName="x" yName="y" explode explodeIndex={2} explodeOffset="10%" dataLabel={{ visible: true, position: 'Inside', name: 'text', font: { fontWeight: '600' } }} radius="100%" /> */}
          {notjobs.map((item, index) => <AccumulationSeriesDirective xName="title" dataSource={item} yName="y" explode explodeIndex={1} explodeOffset="10%" dataLabel={{ visible: true, position: 'Inside', name: 'text', font: { fontWeight: '600' } }} radius="100%" key={index} />)}

        </AccumulationSeriesCollectionDirective>
      </AccumulationChartComponent>
    </div>
  );
  const colChart = () => (
    <div style={{ height: '90%', width: '100%' }}>
      <div className="card">
        <span className="e-icons jobs" />
        <div className="card-content text">Visits by Job</div>
      </div>
      <ToolbarComponent
        id="toolbar"
        orientation="Horizontal"
        onClick={chartActions}
      >
        <ItemsDirective>
          <ItemDirective text="Print" prefixIcon="e-print" />
          <ItemDirective text="Export" prefixIcon="e-export-excel" />
        </ItemsDirective>
      </ToolbarComponent>
      <ChartComponent
        id="colChart"
        ref={(chart) => { chart1 = chart; }}
        style={{ textAlign: 'center' }}
        load={Chartload}
        legendSettings={{ visible: true }}
        primaryXAxis={{ valueType: 'Category', interval: 1, majorGridLines: { width: 0 } }}
        primaryYAxis={{ labelFormat: '{value}', lineStyle: { width: 0 }, maximum: metricmax, interval: 20, majorTickLines: { width: 0 }, minorTickLines: { width: 0 } }}
        chartArea={{ border: { width: 0 } }}
        allowExport
        tooltip={{ enable: true }}
      >
        <Inject services={[ColumnSeries, Legend, Tooltip, Category, Export, DataLabel]} />
        <SeriesCollectionDirective>
          {datajobs.map((item, index) => <SeriesDirective xName="xX" dataSource={item} yName="y" name={item[0].title} type="Column" width={2} key={index} marker={{ dataLabel: { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' } } }} />)}
        </SeriesCollectionDirective>
      </ChartComponent>
    </div>
  );
  if (loading) {
    return <p>Loading... </p>;
  }
  const jobids = [];
  data[2].forEach((job) => {
    if (job._id.jobId === '') {
      job._id.title = 'Unspecified';
    }
    const i = jobids.indexOf(job._id.jobId);
    const dateObj = new Date(job._id.year, job._id.month, job._id.day);
    const month = dateObj.getUTCMonth(); // months from 1-12
    // const day     = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    const newDate = `${month}/${year}`;
    if (i === -1) {
      jobids.push(job._id.jobId);
      const newrec = [];
      newrec.push({
        title: job._id.title,
        id: job._id.jobId,
        x: dateObj,
        xX: newDate,
        y: job.count,
      });
      datajobs.push(newrec);
    } else {
      const newrec = {
        title: job._id.title,
        id: job._id.jobId,
        x: dateObj,
        xX: newDate,
        y: job.count,
      };
      datajobs[i].push(newrec);
    }
    if (job.count > metricmax) {
      setMetricMax(job.count);
    }
  });
  // Notifications
  const notids = [];
  data[5].forEach((not) => {
    if (not._id.organizationid === '') {
      not._id.title = 'Unspecified';
    }
    const i = notids.indexOf(not._id.organizationid);
    const dateObj = new Date(not._id.year, not._id.month, 1);
    const newDate = `${not._id.month}/${not._id.year}`;
    if (i === -1 && notjobs.length === 0) {
      notids.push(not._id.organizationid);
      const newrec = [];
      newrec.push({
        title: `${not._id.organization[0]} ${newDate}`,
        org: `${not._id.organization[0]}`,
        id: not._id.organizationid,
        x: dateObj,
        xX: newDate,
        y: not.count,
      });
      total += not.count;
      notjobs.push(newrec);
    } else {
      const newrec = {
        title: `${not._id.organization[0]} ${newDate}`,
        org: `${not._id.organization[0]}`,
        id: not._id.organizationid,
        x: dateObj,
        xX: newDate,
        y: not.count,
      };
      notjobs[0].push(newrec);
      total += not.count;
    }
    if (not.count > notmax) {
      setNotMax(not.count);
    }
  });

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/How_to_Save_Dashboard_Data__-P7DB2H5Qhi8G_0IzO72Aw"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Dashboards" title="Dashboard/Analytics" />
      </div>
      <div className="control-section" id="target_dash" style={{ position: 'relative', zIndex: '1' }}>
        <div className="col-lg-12 col-sm-12 col-md-12" id="dashboard_sidebar_section">
          <div id="analytic_head">
            <div className="header">
              <div className="menu">
                <span className="e-icons expand" />
              </div>
              <div className="searchContent">
                <div className="analysis">Monaco Analysis Dashboard</div>
              </div>
            </div>
          </div>
          <ToolbarComponent
            id="toolbar"
            orientation="Horizontal"
            onClick={setUserPreferences}
          >
            <ItemsDirective>
              <ItemDirective text="Home" prefixIcon="e-home" />
              <ItemDirective text="Save" prefixIcon="e-save" />
              <ItemDirective template={actionComponent} prefixIcon="e-settings" />
            </ItemsDirective>
          </ToolbarComponent>
          <div id="analytic_target">
            <div className="sidebar-content">
              <div className="dashboardParent">
                <DashboardLayoutComponent
                  id="analytic_dashboard"
                  ref={(dash) => { dashObj = dash; }}
                  allowResizing
                  // cellAspectRatio={100 / 85}
                  cellSpacing={cellSpacing}
                  resizableHandles={resize}
                  columns={6}
                >
                  <PanelsDirective>
                    {settingNotification ? <PanelDirective id="card1" minSizeY={2} sizeX={2} sizeY={1} row={0} col={0} content={card1} /> : null}
                    {settingJobs ? <PanelDirective id="card2" sizeX={2} minSizeY={2} sizeY={1} row={0} col={2} content={card2} /> : null}
                    {settingInventory ? <PanelDirective id="card3" sizeX={2} minSizeY={2} sizeY={1} row={1} col={0} content={card3} /> : null}
                    {settingActive ? (
                      <PanelDirective
                        id="pie1"
                        sizeX={2}
                        minSizeY={2}
                        sizeY={2}
                        row={5}
                        col={0}
                        content={pie}
                        header={headerActive}
                      />
                    ) : null}
                    {settingNotification ? <PanelDirective id="chart1" sizeX={2} minSizeY={2} sizeY={2} row={1} col={4} content={colChart} /> : null}
                    {settingStatistics ? <PanelDirective id="pie2" sizeX={2} minSizeY={2} sizeY={2} row={2} col={0} content={pieChart} header={headerNotifications} /> : null}
                    {!loading && settingAQI ? <PanelDirective id="chart3" sizeX={4} minSizeY={2} sizeY={2} row={3} col={2} content={climateChart} header={headerAQI} /> : null}
                    {settingTraffic ? <PanelDirective id="card4" sizeX={4} minSizeY={2} sizeY={2} row={2} col={2} content={visitorsChart} header={headerTraffic} /> : null}
                    {settingAssets ? <PanelDirective id="assetpie" sizeX={4} minSizeY={2} sizeY={2} row={2} col={2} content={assetPie} header={headerAssets} /> : null}
                  </PanelsDirective>
                </DashboardLayoutComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Analytics;
